import classnames from 'classnames';
import type { FunctionComponent, MouseEvent } from 'react';

import { ColorSelectItem } from './components/ColorSelectItem/ColorSelectItem';
import { MultiSelectItem } from './components/MultiSelectItem/MultiSelectItem';
import type { Item, MultiSelectType } from './interfaces';

import styles from './MultiSelect.module.scss';

interface Props {
  className?: string;
  type?: MultiSelectType;
  topSeparator?: boolean;
  items: Item[];
  onChange?(event: MouseEvent<HTMLInputElement>, item: Item): void;
  hideItemChecker?: boolean;
}

const nbItemsToDisplay = parseInt(styles.nbItemsToDisplay, 10);

export const MultiSelect: FunctionComponent<Props> = ({
  className,
  type,
  topSeparator,
  items,
  onChange,
  hideItemChecker,
}) => {
  const rootClassnames = classnames(styles.root, className, {
    [styles.withScrollbar]: items.length > nbItemsToDisplay,
    [styles.topSeparator]: topSeparator,
  });

  if (!items.length || items.every((item) => item === undefined)) return null;

  return (
    <div className={rootClassnames} data-testid="multi-select">
      {items.map((item) =>
        type === 'color' ? (
          <ColorSelectItem
            className={styles.item}
            key={`${item.id}-${item.value}`}
            item={item}
            onClick={onChange}
          />
        ) : (
          <MultiSelectItem
            className={styles.item}
            key={`${item.id}-${item.value}`}
            item={item}
            onClick={onChange}
            hideChecker={hideItemChecker}
          />
        ),
      )}
    </div>
  );
};

MultiSelect.displayName = 'MultiSelect';
